<template>
    <footer class="po-footer" :class="{ 'po-footer--logged': logueado }">
        <div class="po-footer-inner">
            <router-link to="/" class="po-footer-brand" title="Inicio">
                <img src="/favicon.ico" width="24" height="24" alt="">
            </router-link>
            <span class="po-footer-text">Puestify</span>
            <a class="po-footer-icon" href="https://instagram.com/puestify" target="_blank" rel="noopener noreferrer" title="Instagram">
                <img src="/recursos/instagram.png" width="20" height="20" alt="">
            </a>
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            logueado: false,
        };
    },
    mounted() {
        this.logueado = !!localStorage.getItem('usuario');
    },
};
</script>

<style scoped>
.po-footer {
    position: relative;
    width: 100%;
    flex-shrink: 0;
    margin-top: auto;
    border-top: 1px solid rgba(148, 163, 184, 0.15);
    background-color: var(--po-page-bg-base, #152238);
    background-image: linear-gradient(180deg, #182840 0%, #0f172a 100%);
}

.po-footer-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.5rem 0.75rem;
    padding: 0.45rem max(0.75rem, env(safe-area-inset-left)) 0.5rem max(0.75rem, env(safe-area-inset-right));
    font-size: 0.8125rem;
    color: #94a3b8;
}

.po-footer-brand {
    display: flex;
    align-items: center;
    opacity: 0.85;
    transition: opacity 0.2s ease;
}

.po-footer-brand:hover {
    opacity: 1;
}

.po-footer-text {
    font-weight: 500;
    color: #cbd5e1;
}

.po-footer-icon {
    display: flex;
    align-items: center;
    opacity: 0.85;
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.po-footer-icon:hover {
    opacity: 1;
    transform: scale(1.06);
}

@media screen and (max-width: 992px) {
    .po-footer--logged {
        padding-bottom: calc(0.45rem + 56px + env(safe-area-inset-bottom, 0));
    }
}
</style>
